import React from "react";

import {Link} from "@pg-design/link-module";
import {promotionOfferPluralize} from "@pg-mono/string-utils";

import {getRegionPromotionLink} from "../../../promotion/helpers/get_region_promotion_link";
import {ISelectedRegion} from "../actions/offer_list_selected_data_actions";

interface IProps {
    selectedRegion: ISelectedRegion[];
    className?: string;
}

export const OfferListPromotionLink = React.memo((props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    const promotionListingLink = getRegionPromotionLink(
        props.selectedRegion?.[0]?.slug,
        props.selectedRegion?.[0]?.parent?.slug,
        props.selectedRegion?.[0]?.stats
    );

    return (
        <>
            {" "}
            {promotionListingLink && (
                <Link href={promotionListingLink} className={props.className}>
                    w tym {promotionsCount} {promotionOfferPluralize(promotionsCount)}
                </Link>
            )}
        </>
    );
});
import React from "react";

import {Link} from "@pg-design/link-module";
import {promotionOfferPluralize} from "@pg-mono/string-utils";

import {getRegionPromotionLink} from "../../../promotion/helpers/get_region_promotion_link";
import {ISelectedRegion} from "../actions/offer_list_selected_data_actions";

interface IProps {
    selectedRegion: ISelectedRegion[];
    className?: string;
}

export const OfferListPromotionLink = React.memo((props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    const promotionListingLink = getRegionPromotionLink(
        props.selectedRegion?.[0]?.slug,
        props.selectedRegion?.[0]?.parent?.slug,
        props.selectedRegion?.[0]?.stats
    );

    return (
        <>
            {" "}
            {promotionListingLink && (
                <Link href={promotionListingLink} className={props.className}>
                    w tym {promotionsCount} {promotionOfferPluralize(promotionsCount)}
                </Link>
            )}
        </>
    );
});
